import {createApp} from 'vue'
import DropdownWithTags from './DropdownWithTags'

const el = '.kb-component--dropdown-with-tags'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DropdownWithTagsDOM)=>{
            const props = {
                tooltipText: DropdownWithTagsDOM.dataset.tooltiptext,
                errorMessageLabel:
                    DropdownWithTagsDOM.dataset.errormessagelabel,
                helpMessageLabel: 
                    DropdownWithTagsDOM.dataset.helpmessagelabel,
                placeholder: DropdownWithTagsDOM.dataset.placeholder,
                tagsTitle: DropdownWithTagsDOM.dataset.tagstitle,
                label: DropdownWithTagsDOM.dataset.label,
                legend: DropdownWithTagsDOM.dataset.legend,
                isRequired: !!(
                    DropdownWithTagsDOM.dataset.isrequired === 'true'
                ),
                fieldName: DropdownWithTagsDOM.dataset.fieldname,
                selectOptions: JSON.parse(
                    DropdownWithTagsDOM.dataset.selectoptions
                )
            }

            const component = createApp(DropdownWithTags, props).use(Store)
            component.mount(DropdownWithTagsDOM)
        })
    }
}